import { useMediaQuery, useTheme } from "@mui/material";

export const useOnMobile = () => {
    const theme = useTheme();
    const query = theme && (theme as any).breakpoints ? (theme as any).breakpoints.down("sm") : "(max-width:600px)";
    return useMediaQuery(query as any);
};
